
export class Applicant {
  id: number;
  isEnabled: boolean;
  name: string;
  email: string;
  password: string;
  phone: string;
  hasNewsletter: boolean;
  hasTerms: boolean;


  constructor(applicant?: { name?: string, email?: string, password?: string, isEnabled?: boolean, id?: number, phone?: string,
    hasNewsletter?: boolean, hasTerms?: boolean}) {
    if (applicant) {
      this.id = applicant.id;
      this.isEnabled = applicant.isEnabled;
      this.name = applicant.name;
      this.email = applicant.email;
      this.password = applicant.password;
      this.phone = applicant.phone;
      this.hasNewsletter = applicant.hasNewsletter;
      this.hasTerms = applicant.hasTerms;
    }
  }

}
